import React from 'react'
import { t } from 'ttag'
import { ToolTip, useTooltip } from 'components/common/ToolTip'
import Icon from 'components/common/Icon'
import './AtsLock.scss'

// disable features and set a help message
export type AtsLockContextValue = {
  owner?: string
  isAtsLocked?: boolean
}

export const AtsLockContext = React.createContext<AtsLockContextValue | null>(
  null,
)

export const LockMessage = ({ owner }: { owner?: string }) => (
  <>
    <p>
      {t`This position was created from`} <strong>{owner}</strong>
    </p>
    <p>{t`Some actions are therefore not available in the Ebber Dashboard.`}</p>
  </>
)

export const OwnedBy = ({ owner }: { owner?: string }) => {
  const [props, toolTipProps] = useTooltip<HTMLDivElement>()
  return owner ? (
    <div {...props} className={'OwnedBy'}>
      <LockIcon /> <span className="owner">{owner}</span>
      <ToolTip {...toolTipProps}>
        <LockMessage owner={owner} />
      </ToolTip>
    </div>
  ) : null
}

export const LockIcon = () => (
  <div className="LockIcon">
    <Icon name="lock" />
  </div>
)
